module.exports = __webpack_public_path__ + "static/WalmartChart-357338f604360fba54e0cc39ccec604b.svg";